import anime from 'animejs';
import Medusa from '@adoratorio/medusa';
import engine from '@/scripts/engine';

function clamp(v, min = 0, max = 1) {
  return Math.min(max, Math.max(min, v));
}

function invlerp(a, b, v) {
  return clamp((v - a) / (b - a));
}

function animationFigure(el) {
  return anime({
    targets: el,
    translateY: [40, -40],
    scaleX: {
      value: [1, 0.9],
      duration: 55,
      delay: 45,
      easing: 'easeInOutSine',
    },
    scaleY: {
      value: [1, 1.1],
      duration: 65,
      delay: 45,
      easing: 'easeInOutSine',
    },
    easing: 'linear',
    duration: 100,
    autoplay: false,
  });
}

function animationImg(el) {
  return anime({
    targets: el,
    translateY: ['-10%', '10%'],
    easing: 'linear',
    duration: 100,
    autoplay: false,
  });
}

function animationImgMobile(el) {
  return anime({
    targets: el,
    scaleX: {
      value: [1, 0.8],
      duration: 100,
      delay: 0,
      easing: 'easeInOutSine',
    },
    translateY: {
      value: ['10%', '-10%'],
      duration: 100,
      easing: 'linear',
    },
    duration: 100,
    autoplay: false,
  });
}

export default {
  id: 'parallax',
  nodes: [],
  container: document.getElementById('app'),
  threshold: Medusa.THRESHOLD.BEARLY,
  offsets: '30px 0px 30px 0px',
  emitGlobal: false,
  callback: ({ isIntersecting, target }) => {
    if (isIntersecting) {
      const phoneQuery = window.matchMedia('(min-width: 769px)');

      const { height } = target.getBoundingClientRect();

      // eslint-disable-next-line max-len
      const scroll = offsetTop => invlerp(-window.innerHeight, height, -offsetTop);

      let parallaxFigure;
      if (phoneQuery.matches) parallaxFigure = animationFigure(target);

      let parallaxImg;
      if (phoneQuery.matches) parallaxImg = animationImg(target.children[0]);
      else parallaxImg = animationImgMobile(target.children[0]);

      engine.add(() => {
        if (parallaxFigure) parallaxFigure.seek(scroll(target.getBoundingClientRect().top) * 100);
        parallaxImg.seek(scroll(target.getBoundingClientRect().top) * 100);
      }, target);
    } else {
      engine.remove(target);
    }
  },
  mode: Medusa.MODE.DEFAULT,
};
